import ModelFactory from 'business/models/ModelFactory';
import { CryoDTO, CryoprotectantClient, CrystalCryoDTO } from 'business/models/Models';

export default class CrystalService {
  static myInstance: CrystalService = null;
  _cryoprotectantClient: CryoprotectantClient;

  constructor() {
    this._cryoprotectantClient = ModelFactory(CryoprotectantClient, false, true);
  }

  static getInstance() {
    if (CrystalService.myInstance == null) {
      CrystalService.myInstance = new CrystalService();
    }

    return this.myInstance;
  }

  async getAllCryoprotectantsOfCurrentUser(): Promise<CryoDTO[]> {
    const cryoprotectants: CryoDTO[] =
      await this._cryoprotectantClient.getAllCryoprotectantsOfCurrentUser();
    return cryoprotectants;
  }

  async addCryoprotectants(cryoList: CryoDTO[]): Promise<CryoDTO[]> {
    return await this._cryoprotectantClient.saveCryoprotectants(cryoList);
  }

  async deleteCryoprotectants(cryoList: CryoDTO[]) {
    await this._cryoprotectantClient.deleteCryoprotectants(cryoList);
  }

  async assignCryosToCrystals(crystalCryoList: CrystalCryoDTO[]) {
    await this._cryoprotectantClient.assignCryoToCrystals(crystalCryoList);
  }
  async getInUseCryoprotectantsByIds(cryoIds: number[]): Promise<CryoDTO[]> {
    return await this._cryoprotectantClient.getInUseCryoprotectantsByIds(cryoIds);
  }
}
